/**
 * Canonical storage folder layout shared by every document bucket
 * (credit-notes, expense-receipts, invoices-issued):
 *
 *     {orgId}/{YYYY}/Q{quarter}/{MM}
 *
 * The period is derived from the UPLOAD date — it's a filing convenience for
 * browsing objects in the bucket, not an accounting boundary. The authoritative
 * period for any document is always its own date column in the database
 * (doc_date / invoice date / ledger date), never its storage path.
 *
 * Each caller appends its own file name to this prefix (a random uuid for
 * receipts/credit notes, a stable "Invoice_<number>.pdf" for invoices), so the
 * folder structure is identical across buckets while the leaf keeps whatever
 * naming/uniqueness semantics that bucket needs.
 */
export function storagePeriodPrefix(orgId: string, date: Date = new Date()): string {
    const year = date.getFullYear();
    const quarter = Math.floor(date.getMonth() / 3) + 1;
    const month = String(date.getMonth() + 1).padStart(2, '0');
    return `${orgId}/${year}/Q${quarter}/${month}`;
}
